import { ChevronRight, ArrowRight } from 'lucide-react';
import { TOOLS_DATA } from '../data/toolsData';
import { ARTICLES_DATA } from '../data/articlesData';
import ToolCard from '../components/ToolCard';

// トップに載せるツール（toolsData.js の id）。全部並べると長くなるので、使用頻度の高いものに絞る
const FEATURED_TOOL_IDS = [7, 1, 2, 3, 4, 9];
const LATEST_ARTICLE_COUNT = 6;

export default function HomePage({ setCurrentPage }) {
  const featuredTools = FEATURED_TOOL_IDS
    .map((id) => TOOLS_DATA.find((t) => t.id === id))
    .filter(Boolean);
  // 公開日の新しい順に並べる（データの並び順に依存しない）
  const recentArticles = [...ARTICLES_DATA]
    .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0))
    .slice(0, LATEST_ARTICLE_COUNT);

  return (
    <div>
      {/* ヒーローセクション */}
      <section className="bg-amber-50 py-20 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-green-700 font-medium text-sm mb-3 tracking-widest uppercase">Rinshō Nurse Lab</p>
          <h1 className="text-3xl md:text-4xl font-black text-gray-800 leading-tight mb-5" style={{fontFamily: "'M PLUS Rounded 1c', sans-serif"}}>
            現場の看護師による<br />
            <span className="text-green-800">看護師のための知識とツール</span>
          </h1>
          <p className="text-gray-500 text-base md:text-lg mb-8 leading-relaxed">
            「なんとなく」で終わらせない。<br />
            根拠のある判断と、<span className="font-bold text-gray-700">チームで基準を揃える</span>ための記事とツールを、<br className="hidden md:block" />
            現役の看護師が作っています。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => setCurrentPage('tools')}
              className="bg-green-800 text-white px-6 py-3 rounded-lg font-medium hover:bg-green-900 transition-colors flex items-center justify-center gap-2"
            >
              ツールを使う <ArrowRight size={18} />
            </button>
            <button
              onClick={() => setCurrentPage('articles')}
              className="bg-white text-green-800 px-6 py-3 rounded-lg font-medium border border-green-300 hover:bg-amber-50 transition-colors flex items-center justify-center gap-2"
            >
              記事を読む <ArrowRight size={18} />
            </button>
          </div>
          <p className="text-gray-400 text-xs mt-6">ツール{TOOLS_DATA.length}個・記事{ARTICLES_DATA.length}本を公開中。登録不要・無料で使えます。</p>
        </div>
      </section>

      {/* ツールピックアップ */}
      <section className="py-14 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-lg font-bold text-gray-800">よく使われるツール</h2>
            <button
              onClick={() => setCurrentPage('tools')}
              className="text-green-800 text-sm font-medium flex items-center gap-1 hover:underline"
            >
              すべて見る（{TOOLS_DATA.length}個） <ChevronRight size={14} />
            </button>
          </div>
          <p className="text-gray-500 text-sm mb-6">主観を数値に変える。スコアを出して、そのまま報告・記録に使えます。</p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {featuredTools.map((tool) => (
              <ToolCard key={tool.id} tool={tool} setCurrentPage={setCurrentPage} />
            ))}
          </div>
        </div>
      </section>

      {/* 最新記事 */}
      <section className="bg-amber-50 py-14 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-lg font-bold text-gray-800">最新記事</h2>
            <button
              onClick={() => setCurrentPage('articles')}
              className="text-green-800 text-sm font-medium flex items-center gap-1 hover:underline"
            >
              すべて見る（{ARTICLES_DATA.length}本） <ChevronRight size={14} />
            </button>
          </div>
          <p className="text-gray-500 text-sm mb-6">手技・アセスメント・スケール・報告・コミュニケーションまで、「チームで判断を揃える」視点でまとめています。</p>
          <div className="grid md:grid-cols-3 gap-4">
            {recentArticles.map((article) => (
              <button
                key={article.id}
                onClick={() => setCurrentPage(article.page)}
                className="bg-white rounded-xl p-5 shadow-sm text-left hover:shadow-md transition-shadow"
              >
                <span className="bg-green-100 text-green-900 text-xs font-medium px-2.5 py-1 rounded-full">
                  {article.category}
                </span>
                <h3 className="font-bold text-gray-800 text-sm mt-3 mb-2 leading-snug line-clamp-3">{article.title}</h3>
                <p className="text-gray-400 text-xs">{article.date}</p>
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
